
import TestimonialBlock from "./TestimonialBlock";
import FrontpageNewsBlock from "./FrontpageNewsBlock";
import InvestmentsBlock from "./InvestmentsBlock";
import MediaNewsBlock from "./MediaNewsBlock";
import CompanyBlock from "./CompanyBlock";
import EmployeesBlock from "./EmployeesBlock";
import AproachBlock from "./AproachBlock";
import BoardBlock from "./BoardBlock";
import LinkBlock from "./LinkBlock";
import ContactForm from "./ContactForm";
import PendulumBlock from "./PendulumBlock";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

/**
 * Renders different Wagtail block types dynamically.
 */
function BlockRenderer({ blocks, latest_news_articles }) {
  if (!Array.isArray(blocks)) {
    console.error("BlockRenderer received a non-array value:", blocks);
    return <p className="text-gray-500">No content available.</p>;
  }

  return (
    <>
      {blocks.map((block, index) => {
        switch (block.type) {
          case "rich_text":
            return (
              <p
                key={index}
                className="rich-text"
                dangerouslySetInnerHTML={{ __html: block.value }}
              />
            );

          case "paragraph_block":
            return (
              <div className="row justify-content-center paragraph-block">
                <div className="col-lg-8">
                  {block.value.lead ? (
                    <h3 key={index} dangerouslySetInnerHTML={{ __html: block.value.rich_text }} />
                  ) : (
                    <p key={index} className="p-body-1" dangerouslySetInnerHTML={{ __html: block.value.rich_text }} />
                  )}
                </div>
              </div>

            );


          case "contact_form":
            return <ContactForm key={index} {...block.value} />;

          case "pendulum_block":
            return <PendulumBlock />;

          case "image":
            return (
              <figure key={index} className="text-center">
                <img
                  src={`${API_BASE_URL}${block.value.image.original}`}
                  alt="Block Image"
                  className="mx-auto rounded-lg shadow-md"
                />
                {block.value.caption && (
                  <figcaption className="text-gray-500">
                    {block.value.caption}
                  </figcaption>
                )}
              </figure>
            );

          case "quote":
            return (
              <blockquote
                key={index}
                className="border-l-4 border-gray-500 pl-4 italic"
              >
                <p>"{block.value.quote}"</p>
                {block.value.author && <cite>- {block.value.author}</cite>}
              </blockquote>
            );

          case "video":
            return (
              <div key={index} className="text-center">
                <video width="80%" controls>
                  <source src={block.value.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            );

          case "testimonial":
            return <TestimonialBlock key={index} {...block.value} />;

          case "company_block":
            return (
              <CompanyBlock
                key={index}
                {...block.value}
                pageUrl={block.value.page?.url || "#"}
              />
            );


          case "employees_block":
            return (
              <EmployeesBlock
                key={index}
                employees={(block.value.employees || []).map((employee) => ({
                  image: employee.value.employee_image?.original || "",
                  name: employee.value.name || "",
                  text: employee.value.text,
                  phone: employee.value.phone,
                  email: employee.value.email,
                  linked_in: employee.value.linked_in,
                }))}
              />
            );

          case "link_block":
            return (
              <LinkBlock
                key={index}
                links={(block.value.links || []).map((link) => ({
                  link_text: link.value.link_text,
                  link_page: link.value.link_page,
                  link_url: link.value.link_url,
                  document: link.value.document,
                }))}
              />
            );

          case "aproach_block":
            return (
              <AproachBlock
                key={index}
                title={block.value.title}
                intro={block.value.intro}
                points={(block.value.points || []).map((point) => ({
                  title: point.value.title || "",
                  text: point.value.text,
                }))}
              />
            );


          case "board_block":
            return (
              <BoardBlock
                key={index}
                board_members={(block.value.board_members || []).map((board) => ({
                  image: board.value.board_image?.original || "",
                  name: board.value.name || "",
                  text: board.value.text,
                }))}
              />
            );

          case "investments_block":
            return (
              <InvestmentsBlock
                key={index}
                investments={(block.value.investments || []).map(
                  (investment) => ({
                    logo: investment.value.logo?.url || "",
                    image: {
                      normal: investment.value.image?.investment_block_normal || "",
                      retina: investment.value.image?.investment_block_retina || "",
                      alt: investment.value.image?.alt || "Investment image",
                    },
                    description: investment.value.description,
                    statistic: investment.value.statistic,
                    statistic_text: investment.value.statistic_text,
                  })
                )}
              />
            );

          case "media_news_block":
            return <MediaNewsBlock key={index} block={block} />;

          case "frontpage_news_block":
            return (
              <FrontpageNewsBlock
                key={index}
                title={block.value.title}
                subtitle={block.value.subtitle}
                latest_news_articles={latest_news_articles || []}
              />
            );

          case "data":
            return (
              <div key={index} className="data-block">
                {block.value.map((item, itemIndex) => (
                  <div key={itemIndex}>
                    <h4 className="text-md font-semibold">
                      {item.value.title}
                    </h4>
                    <p className="text-lg">{item.value.value}</p>
                  </div>
                ))}
              </div>
            );

          case "news":
            return (
              <div key={index} className="news-block">
                {block.value.image && (
                  <img
                    src={`${API_BASE_URL}${block.value.image.original}`}
                    alt="News"
                    className="rounded-lg shadow-md mb-4"
                  />
                )}
                <p
                  dangerouslySetInnerHTML={{
                    __html: block.value.rich_text,
                  }}
                />
              </div>
            );

          default:
            return (
              <p key={index} className="text-red-500">
                ⚠️ Unknown block type: {block.type}
              </p>
            );
        }
      })}
    </>
  );
}

export default BlockRenderer;
